import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_yynur8ww: FaireBrandEntity = {
  token: "b_yynur8ww",
  type: "brand",
  name: "Good & Well Supply Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/06167057ccfc4368b325ea85bf8cf8acb9f24da8f83ceb69023341003410bfee.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d8a8c9629a6e6f7b85bea7302a97aa67ebd5e8b74925b1fd113d4264e787fad9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/06167057ccfc4368b325ea85bf8cf8acb9f24da8f83ceb69023341003410bfee.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d8a8c9629a6e6f7b85bea7302a97aa67ebd5e8b74925b1fd113d4264e787fad9.jpeg",
  location: "Seattle, WA, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 329,
  isTopShop: true,
  isInsider: true,
  description:
    "Megan McLaughlin, the founder and owner of Good & Well Supply Co., has been making beautiful and natural handmade goods for years. Feeling the call of wanderlust, in 2001 she began a journey to rediscover the beauty and majesty of the American landscape. Living from her tent in national parks and public lands around the country, she inhaled the scents and sights experienced by the people of this continent for thousands of years. Now located in the Pacific Northwest, Megan has started Good & Well to pass on her love of this natural world to you.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:25.831Z",
    importedBy: "entity-db-cli",
  },
};
